import type { ReactNode } from 'react'

export function Terminal({ title = 'bash', children, height }: {
  title?: string; children: ReactNode; height?: number
}) {
  return (
    <div className="term" style={height ? { height } : undefined}>
      <div className="term-bar">
        <div className="lights">
          <span className="light" style={{ background: '#3a2024' }}></span>
          <span className="light" style={{ background: '#3a2f14' }}></span>
          <span className="light" style={{ background: '#1d3320' }}></span>
        </div>
        <span className="title">{title}</span>
      </div>
      <div className="term-body">{children}</div>
    </div>
  )
}
